import React from 'react';
import { NoDataBox } from '../../img';  // GglIcon IconDelete
// import ContentLoader from 'react-content-loader';

const DatasourceIntegration = ({
  lstActiveIntg,
  filterType,
  handleDataSrc,
  arrDataSource,
  viewReviewData,
  isOpenIntegrationModel
}) => {
  //Filter Integration by Widget type name
  if (lstActiveIntg && lstActiveIntg.length > 0) {
    lstActiveIntg = lstActiveIntg.filter(x => x.typ.indexOf(filterType) !== -1);
  }
  // if (lstActiveIntg && lstActiveIntg.length > 0 && widgetById) {
  //   lstActiveIntg = lstActiveIntg.filter(x => x.typ.indexOf(widgetById.wdtnm) !== -1);
  // }

  //Sort Integration by A-Z or Z-A
  lstActiveIntg && lstActiveIntg.sort((a, b) => {
    if (a.dn < b.dn) {
      return -1;
    } if (a.dn > b.dn) {
      return 1;
    }
    return 0;
  });

  //<p>Add integration to show data</p>
  setTimeout(async () => {
    if (document.getElementById('int-dsi') && document.getElementById('int-dsi').innerHTML == '<div></div>') {
      document.getElementById('int-dsi').innerHTML = `<div class='inte-nodata-box'>
      <img src=${NoDataBox} />
      <h5>No data Found</h5>
      <p className='nodata-subtext' style='font-size: 13px; margin: 5px 0px 0px'>Add data source to see real-time preview</p>
      </div>`;
    }
  }, 100);

  return (
    <div className="side-editor-panel side-editor-dataset">
      <div className="">
        <div className="integration-tabs 1236 integration-checklist-block" id="int-dsi">
          <div>
            {lstActiveIntg && lstActiveIntg.length > 0 ? lstActiveIntg.map((value) => {
              return value.items && value.items.length > 0 &&
                value.items.map((obj, ik) => {
                  if (obj.inm == 'googlemybusiness' && obj.d.lc) {
                    if (obj.d.lc && obj.d.lc.length > 0) {
                      return (
                        obj.d.lc.filter(x => x.ia === true).map((fpl, kf) => {
                          let objCountParams = {
                            pglkcnt: 0,
                            pgflcnt: 0,
                            pgrtngcnt: fpl.ratingCount,
                            pgrtngavg: fpl.avgRating,
                            pu: fpl.placeId,
                            iin: obj.inm,
                            rmk: fpl.locationName,
                            dn: value.dn
                          };
                          let isDisabled = false;
                          if (fpl.isListen === true) {
                            isDisabled = true;
                          } else if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                            isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                          }
                          return (<div className="apps-connect-after-list" key={kf}>
                            <div className="apps-integra-img">
                              <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                            </div>
                            <div className="connect-list-name">
                              <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                              <p style={{ cursor: 'pointer' }}>{fpl.locationName}</p>
                              <div className='connect-data-view' style={{ cursor: 'pointer' }} onClick={() => viewReviewData(obj, fpl)}>
                                < svg xmlns="http://www.w3.org/2000/svg" width="12" height="7.767" viewBox="0 0 12 7.767" >
                                  <g id="Group_30210" data-name="Group 30210" transform="translate(698.598 -32.418)">
                                    <path id="Path_19830" data-name="Path 19830" d="M-692.255,35.14a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5A1.5,1.5,0,0,0-692.255,35.14Z" transform="translate(-0.342 -0.338)" fill="#8392a5" />
                                    <path id="Path_19831" data-name="Path 19831" d="M-686.6,36.284a6.413,6.413,0,0,0-5.993-3.865,6.412,6.412,0,0,0-5.991,3.865l-.008.018.008.017a6.412,6.412,0,0,0,5.991,3.865,6.414,6.414,0,0,0,5.993-3.865l.008-.017Zm-1.278.018a5.27,5.27,0,0,1-4.715,2.767,5.269,5.269,0,0,1-4.714-2.767,5.268,5.268,0,0,1,4.714-2.768,5.268,5.268,0,0,1,4.715,2.766Z" fill="#8392a5" />
                                  </g>
                                </svg>&nbsp;
                                <span>View Data</span>
                              </div>
                            </div>
                            <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc">
                              {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                  <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                                </svg>
                              </span> :
                                <label>
                                  <input type="checkbox"
                                    name={fpl.locationName}
                                    defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == fpl.name) return true; return false; }).length > 0 ? true : false}
                                    disabled={isDisabled}
                                    onChange={(e) => handleDataSrc(
                                      obj._id,
                                      fpl.name,
                                      e.target.checked,
                                      objCountParams,
                                      obj
                                    )}
                                  />
                                </label>}
                            </div>
                          </div>);
                        })
                      );
                    }
                  } else if (obj.inm == 'facebook' && obj.d.fb_page) {
                    if (obj.d.fb_page && obj.d.fb_page.length > 0) {
                      return (
                        obj.d.fb_page.filter(x => x.ia === true).map((fpl, kf) => {
                          let objCountParams = {
                            pglkcnt: 0,
                            pgflcnt: 0,
                            pgrtngcnt: fpl.ratingCount,
                            pgrtngavg: fpl.avgRating,
                            pu: `https://www.facebook.com/${fpl.id}`,
                            iin: obj.inm,
                            rmk: fpl.name,
                            dn: value.dn
                          };
                          let isDisabled = false;
                          if (fpl.isListen === true) {
                            isDisabled = true;
                          } else if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                            isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                          }
                          obj.d['filData'] = fpl;
                          return (
                            <div className="apps-connect-after-list" key={kf}>
                              <div className="apps-integra-img">
                                <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                              </div>
                              <div className="connect-list-name">
                                <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                                <p style={{ cursor: 'pointer' }}>{fpl.name}</p>
                                <div className='connect-data-view' style={{ cursor: 'pointer' }} onClick={() => viewReviewData(obj, fpl)}>
                                  < svg xmlns="http://www.w3.org/2000/svg" width="12" height="7.767" viewBox="0 0 12 7.767" >
                                    <g id="Group_30210" data-name="Group 30210" transform="translate(698.598 -32.418)">
                                      <path id="Path_19830" data-name="Path 19830" d="M-692.255,35.14a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5A1.5,1.5,0,0,0-692.255,35.14Z" transform="translate(-0.342 -0.338)" fill="#8392a5" />
                                      <path id="Path_19831" data-name="Path 19831" d="M-686.6,36.284a6.413,6.413,0,0,0-5.993-3.865,6.412,6.412,0,0,0-5.991,3.865l-.008.018.008.017a6.412,6.412,0,0,0,5.991,3.865,6.414,6.414,0,0,0,5.993-3.865l.008-.017Zm-1.278.018a5.27,5.27,0,0,1-4.715,2.767,5.269,5.269,0,0,1-4.714-2.767,5.268,5.268,0,0,1,4.714-2.768,5.268,5.268,0,0,1,4.715,2.766Z" fill="#8392a5" />
                                    </g>
                                  </svg>&nbsp;
                                  <span>View Data</span>
                                </div>
                              </div>
                              <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                                {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                    <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                                  </svg>
                                </span> :
                                  <label>
                                    <input type="checkbox"
                                      name={fpl.name}
                                      defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == fpl.id) return true; return false; }).length > 0 ? true : false}
                                      disabled={isDisabled}
                                      onChange={(e) => handleDataSrc(
                                        obj._id,
                                        fpl.id,
                                        e.target.checked,
                                        objCountParams,
                                        obj
                                      )}
                                    />
                                  </label>}
                              </div>
                            </div>
                          );
                        })
                      );
                    }
                  } else if (obj.inm == 'google' && obj.d.place_id) {
                    let objCountParams = {
                      pglkcnt: 0,
                      pgflcnt: 0,
                      pgrtngcnt: obj.d.rati_count,
                      pgrtngavg: obj.d.avg_rati,
                      pu: obj.d.place_id,
                      iin: obj.inm,
                      rmk: obj.rmk,
                      dn: value.dn
                    };
                    let isDisabled = false;
                    if (obj.d.isListen === true) {
                      isDisabled = true;
                    } else if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                      isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                    }
                    return <div className="apps-connect-after-list" style={{ alignItems: 'start' }} key={ik}>
                      <div className="apps-integra-img">
                        <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                      </div>
                      <div className="connect-list-name">
                        <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                        <p style={{ cursor: 'pointer' }}>{obj.rmk}</p>
                        <div className='connect-data-view' style={{ cursor: 'pointer' }} onClick={() => viewReviewData(obj, '')}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7.767" viewBox="0 0 12 7.767" >
                            <g id="Group_30210" data-name="Group 30210" transform="translate(698.598 -32.418)">
                              <path id="Path_19830" data-name="Path 19830" d="M-692.255,35.14a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5A1.5,1.5,0,0,0-692.255,35.14Z" transform="translate(-0.342 -0.338)" fill="#8392a5" />
                              <path id="Path_19831" data-name="Path 19831" d="M-686.6,36.284a6.413,6.413,0,0,0-5.993-3.865,6.412,6.412,0,0,0-5.991,3.865l-.008.018.008.017a6.412,6.412,0,0,0,5.991,3.865,6.414,6.414,0,0,0,5.993-3.865l.008-.017Zm-1.278.018a5.27,5.27,0,0,1-4.715,2.767,5.269,5.269,0,0,1-4.714-2.767,5.268,5.268,0,0,1,4.714-2.768,5.268,5.268,0,0,1,4.715,2.766Z" fill="#8392a5" />
                            </g>
                          </svg>&nbsp;
                          <span>View Data</span>
                        </div>
                      </div>
                      <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                        {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                            <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                          </svg>
                        </span> :
                          <label>
                            <input type="checkbox"
                              name={obj.rmk}
                              defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == obj._id) return true; return false; }).length > 0 ? true : false}
                              disabled={isDisabled}
                              onChange={(e) => handleDataSrc(
                                obj._id,
                                obj._id,
                                e.target.checked,
                                objCountParams,
                                obj
                              )}
                            />
                          </label>}
                      </div>
                    </div>;
                  } else if (obj.inm == 'facebookpost' && obj.d.fb_page) {
                    if (obj.d.fb_page && obj.d.fb_page.length > 0) {
                      return (
                        obj.d.fb_page.filter(x => x.ia === true).map((fpl, kf) => {
                          let objCountParams = {
                            pglkcnt: 0,
                            pgflcnt: 0,
                            pgrtngcnt: 0,
                            pgrtngavg: 0,
                            pu: '',
                            iin: obj.inm,
                            rmk: fpl.name,
                            dn: value.dn
                          };
                          let isDisabled = false;
                          if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                            isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                          }
                          obj.d['filData'] = fpl;
                          return (
                            <div className="apps-connect-after-list" key={kf}>
                              <div className="apps-integra-img">
                                <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                              </div>
                              <div className="connect-list-name">
                                <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                                <p style={{ cursor: 'pointer' }}>{fpl.name}</p>
                              </div>
                              <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                                {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                    <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                                  </svg>
                                </span> :
                                  <label>
                                    <input type="checkbox"
                                      name={fpl.name}
                                      disabled={isDisabled}
                                      defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == fpl.id) return true; return false; }).length > 0 ? true : false}
                                      onChange={(e) => handleDataSrc(
                                        obj._id,
                                        fpl.id,
                                        e.target.checked,
                                        objCountParams,
                                        obj
                                      )}
                                    />
                                  </label>}
                              </div>
                            </div>
                          );
                        })
                      );
                    }
                  } else if (obj.inm == 'instagrampost' && obj.d.fb_page) {
                    if (obj.d.fb_page && obj.d.fb_page.length > 0) {
                      return (
                        obj.d.fb_page.filter(x => x.ia === true).map((fpl, kf) => {
                          let objCountParams = {
                            pglkcnt: 0,
                            pgflcnt: 0,
                            pgrtngcnt: 0,
                            pgrtngavg: 0,
                            pu: '',
                            iin: obj.inm,
                            rmk: fpl.name,
                            dn: value.dn
                          };
                          obj.d['filData'] = fpl;
                          let isDisabled = false;
                          if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                            isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                          }
                          return (
                            <div className="apps-connect-after-list" key={kf}>
                              <div className="apps-integra-img">
                                <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                              </div>
                              <div className="connect-list-name">
                                <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                                <p style={{ cursor: 'pointer' }}>{fpl.name}</p>
                              </div>
                              <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                                {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                    <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                                  </svg>
                                </span> :
                                  <label>
                                    <input type="checkbox"
                                      name={fpl.name}
                                      disabled={isDisabled}
                                      defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == fpl.id) return true; return false; }).length > 0 ? true : false}
                                      onChange={(e) => handleDataSrc(
                                        obj._id,
                                        fpl.id,
                                        e.target.checked,
                                        objCountParams,
                                        obj
                                      )}
                                    />
                                  </label>}
                              </div>
                            </div>
                          );
                        })
                      );
                    }
                  } else if (obj.inm == 'twitterpost') {
                    if (obj.d.twitUserNames && obj.d.twitUserNames.length > 0) {
                      return (
                        obj.d.twitUserNames.map((fpl, kf) => {
                          let objCountParams = {
                            pglkcnt: 0,
                            pgflcnt: 0,
                            pgrtngcnt: 0,
                            pgrtngavg: 0,
                            pu: '',
                            iin: obj.inm,
                            rmk: fpl.slug,
                            dn: value.dn
                          };
                          obj.d['filData'] = fpl;
                          let isDisabled = false;
                          if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                            isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                          }
                          return (
                            <div className="apps-connect-after-list" key={kf}>
                              <div className="apps-integra-img">
                                <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                              </div>
                              <div className="connect-list-name">
                                <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                                <p style={{ cursor: 'pointer' }}>{fpl.slug}</p>
                              </div>
                              <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                                {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                    <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                                  </svg>
                                </span> :
                                  <label>
                                    <input type="checkbox"
                                      name={fpl.slug}
                                      disabled={isDisabled}
                                      defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == fpl._id) return true; return false; }).length > 0 ? true : false}
                                      onChange={(e) => handleDataSrc(
                                        obj._id,
                                        fpl._id,
                                        e.target.checked,
                                        objCountParams,
                                        obj
                                      )}
                                    />
                                  </label>}
                              </div>
                            </div>
                          );
                        })
                      );
                    }
                  } else if (obj.inm == 'tumblrpost' && obj.d.blogs) {
                    if (obj.d.blogs && obj.d.blogs.length > 0) {
                      return (
                        obj.d.blogs.filter(x => x.ia === true).map((fpl, kf) => {
                          let objCountParams = {
                            pglkcnt: 0,
                            pgflcnt: 0,
                            pgrtngcnt: 0,
                            pgrtngavg: 0,
                            pu: '',
                            iin: obj.inm,
                            rmk: fpl.name,
                            dn: value.dn
                          };
                          let isDisabled = false;
                          if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                            isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                          }
                          obj.d['filData'] = fpl;
                          return (
                            <div className="apps-connect-after-list" key={kf}>
                              <div className="apps-integra-img">
                                <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                              </div>
                              <div className="connect-list-name">
                                <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                                <p style={{ cursor: 'pointer' }}>{fpl.title}</p>
                              </div>
                              <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                                {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                    <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                                  </svg>
                                </span> :
                                  <label>
                                    <input type="checkbox"
                                      name={fpl.title}
                                      disabled={isDisabled}
                                      defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == fpl.uuid) return true; return false; }).length > 0 ? true : false}
                                      onChange={(e) => handleDataSrc(
                                        obj._id,
                                        fpl.uuid,
                                        e.target.checked,
                                        objCountParams,
                                        obj
                                      )}
                                    />
                                  </label>}
                              </div>
                            </div>
                          );
                        })
                      );
                    }
                  } else if (value.typ.indexOf('review') !== -1) {
                    let objCountParams = {
                      pglkcnt: obj.d && obj.d.pglkcnt ? obj.d.pglkcnt : '',
                      pgflcnt: obj.d && obj.d.pgflcnt ? obj.d.pgflcnt : '',
                      pgrtngcnt: obj.d && obj.d.pgrtngcnt ? obj.d.pgrtngcnt : '',
                      pgrtngavg: obj.d && obj.d.pgrtngavg,
                      pu: obj.d && obj.d.url ? obj.d.url : '',
                      iin: obj.inm,
                      rmk: obj.rmk,
                      dn: value.dn,
                      url: obj.d && obj.d.url ? obj.d.url : '',
                    };
                    if (obj.inm == 'capterra') {
                      objCountParams.url = obj.d.pu;
                    }
                    let isDisabled = false;
                    if (obj.d && obj.d.isListen === true) {
                      isDisabled = true;
                    } else if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                      isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                    }
                    return <div className="apps-connect-after-list" key={ik}>
                      <div className="apps-integra-img">
                        <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                      </div>
                      <div className="connect-list-name">
                        <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                        <p style={{ cursor: 'pointer' }}>{obj.rmk}</p>
                        <div className='connect-data-view' style={{ cursor: 'pointer' }} onClick={() => viewReviewData(obj, '')}>
                          < svg xmlns="http://www.w3.org/2000/svg" width="12" height="7.767" viewBox="0 0 12 7.767" >
                            <g id="Group_30210" data-name="Group 30210" transform="translate(698.598 -32.418)">
                              <path id="Path_19830" data-name="Path 19830" d="M-692.255,35.14a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5A1.5,1.5,0,0,0-692.255,35.14Z" transform="translate(-0.342 -0.338)" fill="#8392a5" />
                              <path id="Path_19831" data-name="Path 19831" d="M-686.6,36.284a6.413,6.413,0,0,0-5.993-3.865,6.412,6.412,0,0,0-5.991,3.865l-.008.018.008.017a6.412,6.412,0,0,0,5.991,3.865,6.414,6.414,0,0,0,5.993-3.865l.008-.017Zm-1.278.018a5.27,5.27,0,0,1-4.715,2.767,5.269,5.269,0,0,1-4.714-2.767,5.268,5.268,0,0,1,4.714-2.768,5.268,5.268,0,0,1,4.715,2.766Z" fill="#8392a5" />
                            </g>
                          </svg>&nbsp;
                          <span>View Data</span>
                        </div>
                      </div>
                      <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                        {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                            <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                          </svg>
                        </span> :
                          <label>
                            <input type="checkbox"
                              name={obj.rmk}
                              defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == obj._id) return true; return false; }).length > 0 ? true : false}
                              disabled={isDisabled}
                              onChange={(e) => handleDataSrc(
                                obj._id,
                                obj._id,
                                e.target.checked,
                                objCountParams,
                                obj
                              )}
                            />
                          </label>}
                      </div>
                    </div>;
                  } else if (obj.inm == 'youtubevideogallery') {
                    let objCountParams = {
                      pglkcnt: 0,
                      pgflcnt: 0,
                      pgrtngcnt: 0,
                      pgrtngavg: 0,
                      pu: `https://www.youtube.com/playlist?list=${obj.d.pi}`,
                      iin: obj.inm,
                      rmk: obj.rmk,
                      dn: value.dn
                    };
                    let isDisabled = false;
                    if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                      isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                    }
                    return <div className="apps-connect-after-list" key={ik}>
                      <div className="apps-integra-img">
                        <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                      </div>
                      <div className="connect-list-name">
                        <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                        <p style={{ cursor: 'pointer' }}>{obj.rmk}</p>
                      </div>
                      <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                        {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                            <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                          </svg>
                        </span> :
                          <label>
                            <input type="checkbox"
                              name={obj.rmk}
                              disabled={isDisabled}
                              defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id && da.pid == obj.d.pi) return true; return false; }).length > 0 ? true : false}
                              onChange={(e) => handleDataSrc(
                                obj._id,
                                obj.d.pi,
                                e.target.checked,
                                objCountParams,
                                obj
                              )}
                            />
                          </label>}
                      </div>
                    </div>;
                  } else {
                    let objCountParams = {
                      pglkcnt: 0,
                      pgflcnt: 0,
                      pgrtngcnt: 0,
                      pgrtngavg: 0,
                      pu: '',
                      iin: obj.inm,
                      rmk: obj.rmk,
                      dn: value.dn
                    };
                    let isDisabled = false;
                    if (localStorage.getItem('W_LOAD_DS_DATA') && JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'))) {
                      isDisabled = JSON.parse(localStorage.getItem('W_LOAD_DS_DATA'));
                    }
                    return <div className="apps-connect-after-list" key={ik}>
                      <div className="apps-integra-img">
                        <img style={{ cursor: 'pointer' }} className="" src={value.img} alt="icon" />
                      </div>
                      <div className="connect-list-name">
                        <h4 style={{ cursor: 'pointer' }}>{value.dn}</h4>
                        <p style={{ cursor: 'pointer' }}>{obj.rmk}</p>
                      </div>
                      <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
                        {isDisabled === true ? <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                            <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                          </svg>
                        </span> :
                          <label>
                            <input type="checkbox"
                              name={obj.rmk}
                              disabled={isDisabled}
                              defaultChecked={arrDataSource.filter((da) => { if (da.uid == obj._id) return true; return false; }).length > 0 ? true : false}
                              onChange={(e) => handleDataSrc(
                                obj._id,
                                '',
                                e.target.checked,
                                objCountParams,
                                obj
                              )}
                            />
                          </label>}
                      </div>
                    </div>;
                  }
                });
            }) :
              <div className="col-xs-12 mt-15">
                <div class='inte-nodata-box'>
                  <img src={NoDataBox} />
                  <h5>No data Found</h5>
                  <p className='nodata-subtext' style={{ fontSize: '13px', margin: '5px 0px 0px' }}>Add data source to see real-time preview</p>
                </div>

                {/* <p className='text-center'>No record found</p> */}
              </div>
            }

          </div>
        </div >
        <a class='nf-btn btn-default btn-add-integration' onClick={() => isOpenIntegrationModel()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="13.421" height="13.423" viewBox="0 0 13.421 13.423">
            <path id="Path_19842" data-name="Path 19842" d="M-355.856,43.72a.928.928,0,0,0,.927-.927V37.935h4.858a.927.927,0,0,0,.926-.927.928.928,0,0,0-.926-.927h-4.858V31.223a.928.928,0,0,0-.927-.926.928.928,0,0,0-.926.926v4.858h-4.859a.928.928,0,0,0-.925.927.927.927,0,0,0,.925.927h4.859v4.858A.928.928,0,0,0-355.856,43.72Z" transform="translate(362.566 -30.297)" fill="#3cca73" />
          </svg> &nbsp;
          Add Integration
        </a>
      </div>
    </div>
  );
};

export default DatasourceIntegration;


// WEBPACK FOOTER //
// ./src/components/Widget/DatasourceIntegration.js